import { DocumentNode, gql } from '@apollo/client';
import { Button, ButtonProps, Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { VoteButton_AnswerFragment } from './graphql-types/VoteButton_AnswerFragment';

export const VoteButton: React.FC<
  {
    answer: VoteButton_AnswerFragment;
    handleVote: () => Promise<void>;
    userVotedForOption: boolean;
  } & ButtonProps
> & {
  answerFragment: DocumentNode;
} = ({ answer, handleVote, userVotedForOption, ...buttonProps }) => {
  return answer.currentUserCanRespondToPost ? (
    <Button
      {...buttonProps}
      size="xs"
      variant="outline"
      onClick={handleVote}
      colorScheme="gray"
      isActive={userVotedForOption}
      {...(userVotedForOption ? { color: 'primary.500' } : {})}
    />
  ) : (
    <Tooltip
      hasArrow
      label={'Only members can upvote or downvote answers.'}
      shouldWrapChildren
    >
      <Button
        {...buttonProps}
        size="xs"
        variant="outline"
        colorScheme="gray"
        isDisabled
      />
    </Tooltip>
  );
};
VoteButton.answerFragment = gql`
  fragment VoteButton_AnswerFragment on AnswerV2 {
    _id
    currentUserCanRespondToPost
  }
`;
